let id = 0;

export default function useUid() {
	return '__EFVID_' + String(id++);
}
